exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody.drawer-open {\n    overflow: hidden;\n}\n", ""]);

// exports
